import indexReplaceAll from "./index-replace-all";

/**
 * Replace `::` in brackets
 * @param {String} input
 * @returns {String}
 */
const replaceResolutions = (input) => {
  if (input.includes("[") && input.includes("::")) {
    return input.replace(/(\s)?\[[^\[\]]*::[^\[\]]*\](\s)?/g, (string) => {
      string = string.replace(/^ \[/, "⌣[");
      string = string.replace(/\] $/, "]⌣");

      return string.replace(/\s\w+::/g, (item) => {
        return item.replace(" ", "✦").replace("::", "▹");
      });
    });
  } else {
    return input;
  }
};

export default replaceResolutions;
